import { CryptoIconsBySlugMap } from "src/Common/utils/cryptosAssets/types";
import { get } from "lodash";
import { CSSProperties, useMemo } from "react";
import cryptoIconsBySlugMap from "../../utils/cryptosAssets/cryptoIconsBySlugMap.json";

enum Variants {
  color = "color",
  black = "black",
  white = "white",
  icon = "icon",
}

interface Props {
  symbol?: string;
  slug?: string;
  variant?: Variants;
  style?: CSSProperties;
}

export function CryptoIcon({
  symbol,
  slug,
  variant = Variants.color, // TODO: support colors
  ...rest
}: Props) {
  const assetUrl = useMemo(
    () =>
      get(cryptoIconsBySlugMap as CryptoIconsBySlugMap, `${slug}`)?.img_url ??
      "/assets/cryptoIcons/generic.svg",
    [slug]
  );

  return (
    <img
      alt={symbol}
      src={assetUrl}
      onError={(e) => {
        e.currentTarget.src = "/assets/cryptoIcons/generic.svg";
      }}
      style={{ height: "2rem" }}
      {...rest}
    />
  );
}
